import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import AppContainer from "../../components/containers/AppContainer";
import DashboardChart from "./../../components/charts/DashboardChart";

const RenderProfit = ({ icon, title, value }) => {
  return (
    <Stack direction={"row"} alignItems={"center"} gap={2}>
      <img src={icon} width={55} height={55} />
      <Typography variant="body1" fontWeight={600}>
        {title}
      </Typography>
      <Typography fontSize={"1.125rem"} fontWeight={600}>
        ${value}
      </Typography>
    </Stack>
  );
};

const VendorEarningStats = ({ data, state }) => {
  return (
    <AppContainer>
      <Stack
        px={2.5}
        py={3}
        direction={{ md: "row" }}
        alignItems={{ md: "center" }}
        justifyContent={"space-between"}
        gap={2}
      >
        <Stack>
          <Typography variant="h5" fontWeight={600}>
            {`${state?.role == "user" ? "User" : "Vendor"}`} Earning Stats
          </Typography>
          <Typography fontSize={"1.125rem"} color={"customColor.dustyGray"}>
            Yearly Earning Overview
          </Typography>
        </Stack>
        {/* <Stack
          direction={{ sm: "row" }}
          alignItems={{ md: "center" }}
          gap={{ xs: 2, md: 4 }}
        >
          <RenderProfit
            icon={APP_ICONS.profitBgIconBlue}
            title={"Total Sales"}
            value={"00.00"}
          />
          <RenderProfit
            icon={APP_ICONS.walletBgIcon}
            title={"Wallet Balance"}
            value={"00.00"}
          />
        </Stack> */}
      </Stack>
      <Divider sx={{ mb: 2, borderColor: "#BDBDBD" }} />
      <Stack px={2.5} pb={2}>
        <Typography variant="h5" fontWeight={600}>
          Revenue
        </Typography>
        <Box mt={3} height={{ xs: 250, md: 400 }}>
          {data?.length > 0 ? (
            <DashboardChart data={data} />
          ) : (
            <Typography
              color="black"
              fontSize={14}
              fontWeight={700}
              textAlign="center"
              padding="30px 0"
            >
              No Revenue Yet!
            </Typography>
          )}
        </Box>
      </Stack>
    </AppContainer>
  );
};

export default VendorEarningStats;
